import { Textarea } from 'components/UI/V3/Forms/Textarea/Textarea';
import React from 'react';
import { useReportBuilder } from './ReportBuilderProvider';
import styles from './ReportBuilder.module.scss';

const GeneralNotesFieldComponent: React.FC = () => {
    const { generalNotes, setGeneralNotes, reportRevision } = useReportBuilder();

    const changeHandler = React.useCallback(
        (e: React.ChangeEvent<HTMLTextAreaElement>) => setGeneralNotes(e.target.value),
        [setGeneralNotes]
    );

    return (
        // Textarea seeds its value on mount only; remount on each report load so
        // notes from a previously saved report appear in the field.
        <Textarea
            key={reportRevision}
            value={generalNotes}
            maxLength={2000}
            placeholder="Add general notes about this report..."
            onChange={changeHandler}
            className={styles.generalNotes}
        />
    );
};

export const GeneralNotesField = React.memo(GeneralNotesFieldComponent);
